import React from 'react';
import ClientInput from '../../../../../components/ClientInput';

const ClientSection = ({ client, onSelectClient, className = '' }) => {
  return (
    <div className={`bg-white dark:bg-gray-800 rounded-lg p-4 ${className}`}>
      <h2 className="font-medium mb-3 text-gray-900 dark:text-white">Cliente</h2>
      <ClientInput onClientChange={onSelectClient} />
    </div>
  );
};

export default ClientSection; 